import {
  fetchPotentialWarningsForBookingTemplates,
  fetchPotentialWarningsForSingleBookings,
  PotentialWarningsResponse
} from "PFApp/booking/services/api";

import { BookingDataItem, BookingFormMode } from "../booking_form.types";
import { isNotLimited } from "../booking_form.utils";
import { BookingFormValues } from "../booking_form_provider";
import { BookingType } from "../booking_type";
import { calculateDateRange, getAvailabilityAffectedBookings } from "./get_availability_affected_bookings";
import { mapToBookingTemplatePayload, mapToSingleBookingPayload } from "./payload.utils";

export type FetchPotentialWarnings = {
  values: Omit<
    BookingFormValues,
    "updateGroupOptionSelected" | "updateRepeatOptionSelected" | "bookings" | "workforceMember"
  > & {
    bookings: Omit<BookingDataItem, "key">[];
    workforceMember: { id: number };
  };
  mode: BookingFormMode;
  initialBookings: BookingDataItem[];
};

const getBookingsToSend = (
  allBookings: BookingDataItem[],
  initialBookings: BookingDataItem[],
  mode: BookingFormMode
): BookingDataItem[] => {
  const isEditAllMode = mode === BookingFormMode.EditAll;

  if (!isEditAllMode || initialBookings.length === 0) {
    return allBookings;
  }

  return getAvailabilityAffectedBookings(allBookings, initialBookings, mode);
};

export const fetchPotentialWarnings = ({
  values,
  mode,
  initialBookings
}: FetchPotentialWarnings): Promise<PotentialWarningsResponse> => {
  const { workforceMember, bookings, bookingType, activityId } = values;
  const isRepeated = bookingType === BookingType.Repeated;
  const profileId = workforceMember.id;

  const validBookings = bookings.filter(isNotLimited) as BookingDataItem[];
  const bookingsToSend = getBookingsToSend(validBookings, initialBookings, mode);

  const dateRange = calculateDateRange(bookingsToSend);

  if (!isRepeated) {
    const potentialBookings = bookingsToSend.map((item) => mapToSingleBookingPayload(item, values, mode));
    return fetchPotentialWarningsForSingleBookings(profileId, potentialBookings, activityId, dateRange);
  } else {
    const potentialBookingTemplates = bookingsToSend.map((item) =>
      mapToBookingTemplatePayload(item, values, mode, profileId)
    );
    return fetchPotentialWarningsForBookingTemplates(profileId, potentialBookingTemplates);
  }
};
